import styled from 'styled-components';
export const StyledSection = styled.article `
  position: relative;
  float: left;
  margin-bottom: 20px;
  width: 100%;
`;
//# sourceMappingURL=Section.styles.js.map